import { Stack } from '@mui/material';
import _ from 'lodash';
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Blacklist_New } from './company-blacklist.types';
import GlobalBlacklistsTable from './global-blacklists-table';
import NoBlacklistItemsAdded from './no-blacklist-items-added';
import NoBlacklistsFound from './no-blacklists-found';

interface Props {
  globalBlacklists: Blacklist_New[];
  removeBlacklistItemsLoading: boolean;

  handleOpenAddBlacklistDialog(): void;

  handleOpenEditBlacklistItemsDialog(blacklist: Blacklist_New): () => void;

  handleOpenEditBlacklistNameDialog(blacklist: Blacklist_New): () => void;

  handleOpenDeleteBlacklistDialog(blacklist: Blacklist_New): () => void;

  handleRemoveSingleBlacklistItem(blacklist: Blacklist_New): (identifier: string) => () => void;
}

const GlobalBlacklists: React.FC<Props> = ({
  globalBlacklists,
  removeBlacklistItemsLoading,
  handleOpenAddBlacklistDialog,
  handleOpenEditBlacklistItemsDialog,
  handleOpenEditBlacklistNameDialog,
  handleOpenDeleteBlacklistDialog,
  handleRemoveSingleBlacklistItem,
}) => {
  const { classes } = useStyles();

  const noBlacklistItemsAdded = _.every(globalBlacklists, (blacklist) => blacklist.items?.length === 0);

  const [noBlacklistItemsAddedInfoOpen, setNoBlacklistItemsAddedInfoOpen] = useState(noBlacklistItemsAdded);

  return (
    <Stack className={classes.blacklists} gap={2}>
      {_.isEmpty(globalBlacklists) ? (
        <NoBlacklistsFound handleOpenAddBlacklistDialog={handleOpenAddBlacklistDialog} />
      ) : (
        <>
          <NoBlacklistItemsAdded open={noBlacklistItemsAddedInfoOpen} handleClose={() => setNoBlacklistItemsAddedInfoOpen(false)} />
          <GlobalBlacklistsTable
            blacklists={globalBlacklists}
            loading={removeBlacklistItemsLoading}
            handleOpenEditBlacklistItemsDialog={handleOpenEditBlacklistItemsDialog}
            handleOpenEditBlacklistNameDialog={handleOpenEditBlacklistNameDialog}
            handleOpenDeleteBlacklistDialog={handleOpenDeleteBlacklistDialog}
            handleRemoveSingleBlacklistItem={handleRemoveSingleBlacklistItem}
          />
        </>
      )}
    </Stack>
  );
};

const useStyles = makeStyles()(() => ({
  blacklists: {
    overflow: 'hidden',
  },
}));

export default GlobalBlacklists;
